import { useState } from 'react';

import { Container } from 'ui';

import { AddCardNew } from '../../components/shared/Cards/AddCard/AddCardNew';
import AddCardSuccessModal from '../../components/shared/Cards/AddCard/AddCardSuccessModal';
import { useInAppShortSessionsLayoutContextLayout } from '../../root/Layouts/InAppShortSessionsLayout';

export const ShortSessionAddCard = () => {
  const { closeNativeBrowser } = useInAppShortSessionsLayoutContextLayout();
  const [showCardSuccess, setShowCardSuccess] = useState<boolean>(false);

  const handleCloseSuccess = () => {
    closeNativeBrowser('/wallet/add-card', 200, 'add-card');
  };
  return (
    <Container p={'lg'}>
      <AddCardNew
        onComplete={() => {
          setShowCardSuccess(true);
        }}
      />

      <AddCardSuccessModal
        opened={showCardSuccess}
        onClick={handleCloseSuccess}
        onClose={handleCloseSuccess}
      />
    </Container>
  );
};
